import { DataSource } from '@n7-frontend/core';
export class DcHomeDS extends DataSource {
  protected transform(data): any {
    return data;
  }
}
